//
//
//
//
//
//

import ProductDetailsPage from '~/components/ProductDetailsPage'
export default {
  auth: false,
  components: {
    ProductDetailsPage
  }
}
